import api from './api';

export interface Task {
  id: number;
  user_id: number;
  title: string;
  description: string;
  assignee_id: string;
  assigned_to_name?: string;
  case_id?: number;
  case_subject?: string;
  priority: 'low' | 'medium' | 'high' | 'urgent';
  status: 'pending' | 'in_progress' | 'completed';
  due_date: string;
  completed: boolean;
  completed_at?: string;
  created_at: string;
  updated_at: string;
}

export interface TaskCreateInput {
  title: string;
  description?: string;
  assignee_id: string;
  case_id?: number;
  priority: string;
  status?: string;
  due_date: string;
}

export interface TaskUpdateInput extends Partial<TaskCreateInput> {
  id: number;
}

const tasksService = {
  getTasks: async (userId: string) => {
    const response = await api.get(`/tasks/${userId}`);
    return response.data.data;
  },

  getTaskById: async (taskId: number, userId: string) => {
    const response = await api.get(`/tasks/${taskId}/${userId}`);
    return response.data;
  },

  createTask: async (data: TaskCreateInput) => {
    const response = await api.post('/tasks', data);
    return response.data;
  },

  updateTask: async (data: TaskUpdateInput) => {
    const response = await api.put(`/tasks/${data.id}`, data);
    return response.data;
  },

  deleteTask: async (taskId: number, userId: string) => {
    const response = await api.delete(`/tasks/${taskId}/${userId}`);
    return response.data;
  },

  toggleComplete: async (taskId: number) => {
    const response = await api.put(`/tasks/${taskId}/toggle`);
    return response.data;
  },

  updateTaskStatus: async (taskId: number, status: string, userId: string) => {
    const response = await api.put(`/tasks/status/${taskId}`, { task_id: taskId, status, user_id: userId });
    return response.data;
  },

  getTasksByCase: async (caseId: number) => {
    const response = await api.get(`/tasks/case/${caseId}`);
    return response.data;
  },

  getTasksByAssignee: async (assigneeId: string) => {
    const response = await api.get(`/tasks/assignee/${assigneeId}`);
    return response.data;
  },

  searchTasks: async (userId: string, query: string) => {
    const response = await api.get(`/tasks/search/${userId}?query=${query}`);
    return response.data;
  },
};

export default tasksService;
